import { Owner, LoadDTO, MercuryLoadDTO, Quote } from 'cargo-chief-commons';
import { LOAD_TAB_TYPES } from '../loads-list/constants';

export const loadsPageStateKey = 'loads-list-page';

export interface LoadsState {
	activeTab: string;
	error: string;
	filters: any[];
	loadingLoadsList: boolean;
	loadsTable: Array<LoadDTO | MercuryLoadDTO>;
	loadsList: Array<LoadDTO>;
	loadingQuotesList: boolean;
	quotesList: Array<Quote>;
	sort: any[];
	totalLoads: number;
	userId: number;
	usersList: Owner[];
	allTabs: string[];
	isBookedTab: boolean;
	isCustomTabBooked: boolean;
	isOpenTab: boolean;
	isCustomTabOpen: boolean;
	isActiveTab: boolean;
	isCustomTabActive: boolean;
}

export const initialState: LoadsState = {
	activeTab: LOAD_TAB_TYPES.ACTIVE,
	error: null,
	filters: [],
	loadingLoadsList: false,
	loadsTable: [],
	loadsList: [],
	loadingQuotesList: false,
	quotesList: [],
	sort: [],
	totalLoads: 0,
	userId: null,
	usersList: [],
	allTabs: [LOAD_TAB_TYPES.ACTIVE, LOAD_TAB_TYPES.OPEN, LOAD_TAB_TYPES.BOOKED],
	isBookedTab: false,
	isCustomTabBooked: false,
	isOpenTab: false,
	isCustomTabOpen: false,
	isActiveTab: false,
	isCustomTabActive: false,
};
